import { createSlice } from '@reduxjs/toolkit';

import { fetchProfileById } from './actions';

import type { UserProfile } from 'store/apiTypes';
import type { UserProfileState } from 'store/userProfile/types';

type profileByIdState = UserProfileState & {
  isViewingOtherUser: boolean;
};
const initialState: profileByIdState = {
  isViewingOtherUser: false,
  data: {} as UserProfile,
  loading: false,
  error: null,
  nicknameDraft: '',
};

export const profileById = createSlice({
  name: 'profileById',
  initialState: initialState,
  reducers: {
    setIsViewingOtherUser(state, action) {
      state.isViewingOtherUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfileById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfileById.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProfileById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to Fetch';
      });
  },
});

export const { setIsViewingOtherUser } = profileById.actions;
export const profileByIdReducer = profileById.reducer;
